import { Access, Level, atLeast } from "../shared/access";

// who is logged in on the web. the desktop app is always fractal

export interface Person {
  id: string;
  name: string;
}

// one account this discord login can act as, for the switcher
export interface MyProfile extends Person {
  alter: boolean;
  color: string;
  avatar: string;
}

interface Me extends Person {
  // the discord account that signed in, which can differ from who it is acting as
  login: string;
  profiles: MyProfile[];
  owner: boolean;
  // null for fractal, who has everything
  access: Access | null;
}

let me: Me = { id: "", name: "Fractal", login: "", profiles: [], owner: true, access: null };

export function setMe(value: Partial<Me> | null): void {
  if (!value) return;
  const owner = value.owner !== false;
  me = {
    id: String(value.id || ""),
    name: String(value.name || "Fractal"),
    login: String(value.login || value.id || ""),
    profiles: value.profiles || [],
    owner,
    access: owner ? null : value.access || {}
  };
  document.body.classList.toggle("not-owner", !owner);
  document.body.classList.toggle("no-chi", !canUse("chi"));
}

export function myId(): string {
  return me.id;
}

export function myProfiles(): MyProfile[] {
  return me.profiles;
}

export function myName(): string {
  return me.name;
}

export function amOwner(): boolean {
  return me.owner;
}

export function myAccess(): Access | null {
  return me.access;
}

// the server checks everything again, this only decides what to show
export function canUse(feature: string, level: Level = "read"): boolean {
  return !me.access || atLeast(me.access[feature], level);
}
